import React from "react";
import ResumeBuilderIcon from "../../../assets/Dashboard/ResumeBuilder.svg";
import ResumeOptimizationIcon from "../../../assets/Dashboard/ResumeOptimization.svg";
import AIPoweredIcon from "../../../assets/Dashboard/AIPowered.svg";
import ProfileManagementIcon from "../../../assets/Dashboard/ProfileManagement.svg";
import JobListingIcon from "../../../assets/Dashboard/JobListing.svg";

const NavItem = ({ icon, label, active, onClick }) => {
  const getIcon = () => {
    switch (icon) {
      case "resume":
        return ResumeBuilderIcon;
      case "optimization":
        return ResumeOptimizationIcon;
      case "ai":
        return AIPoweredIcon;
      case "profile":
        return ProfileManagementIcon;
      case "job":
        return JobListingIcon;
      default:
        return null;
    }
  };

  const iconSrc = getIcon();

  return (
    <li className={`smai-nav-item ${active ? "active" : ""}`} onClick={onClick}>
      <div className="smai-nav-icon">
        <img src={iconSrc} alt={label} />
      </div>
      <span className="smai-nav-label">{label}</span>
    </li>
  );
};

export default NavItem;
